// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".logo[data-v-6f5af56e] {\n  width: 360px;\n  margin-top: 40px;\n  opacity: 0.65;\n}", "",{"version":3,"sources":["/builds/front/game-platform-web/src/pages/Welcome.vue"],"names":[],"mappings":"AACA;EACE,YAAA;EACA,gBAAA;EACA,aAAA;AAAF","file":"Welcome.vue","sourcesContent":["\n.logo{\n  width: 360px;\n  margin-top: 40px;\n  opacity: 0.65;\n}\n"]}]);
// Exports
module.exports = exports;
